module.exports = __webpack_public_path__ + "static/media/500.0f474d31.jpg";